module.exports = {

    B01003: {
        name: 'Overall Population',
        variables: [
            {name:'Overall population',value:'B01003_001E'}
        ]
    },
    B01002:{
        name: 'Median Age By Sex',
        variables:[
            {name:'Median Age',value:'B01002_001E'},
            {name:'Male',value:'B01002_002E'},
            {name:'Female',value:'B01002_003E'}
        ]
    },
    B02001: {
        name: 'Racial Population',
        variables: [
            {name:'Total',value:'B02001_001E'},
            {name:'White',value:'B02001_002E'},
            {name:'Black or African American',value:'B02001_003E'},
            {name:'American Indian and Alaska Native',value:'B02001_004E'},
            {name:'Asian',value:'B02001_005E'},
            {name:'Native Hawaiian and Other Pacific Islander',value:'B02001_006E'},
            {name:'Other race ',value:'B02001_007E'},
            {name:'Two or more races',value:'B02001_008E'},
            {name:'Two races including other race',value:'B02001_009E'},
            {name:'Two races excluding other race and three or more races',value:'B02001_010E'}
        ]
    },
    B19057:{
        name: 'Public Assistance Income for Households',
        variables:[
            {name:'Total',value:'B19057_001E'},
            {name:'With public assistance income',value:'B19057_002E'},
            {name:'No public assistance income',value:'B19057_003E'}
        ]
    },
    B23025: {
        name: 'Employment Status',
        variables:[
            {name:'Total',value:'B23025_001E'},
            {name:'In labor force',value:'B23025_002E'},
            {name:'Civilian labor force',value:'B23025_003E'},
            {name:'Civilian labor force Employed',value:'B23025_004E'},
            {name:'Civilian labor force Unemployed',value:'B23025_005E'},
            {name:'Armed forces',value:'B23025_006E'},
            {name:'Not in labor force',value:'B23025_007E'}
        ]
    },
    B01001: {
        name: 'Sex by Age',
        variables: [
            {name:'Total Population',value:'B01001_001E'},
            {name:'Male Population',value:'B01001_002E'},
            {name:'Male Under 5',value:'B01001_003E'},
            {name:'Male 5-9',value:'B01001_004E'},
            {name:'Male 10-14',value:'B01001_005E'},
            {name:'Male 15-17',value:'B01001_006E'},
            {name:'Male 18-19',value:'B01001_007E'},
            {name:'Male 20',value:'B01001_008E'},
            {name:'Male 21',value:'B01001_009E'},
            {name:'Male 22-24',value:'B01001_010E'},
            {name:'Male 25-29',value:'B01001_011E'},
            {name:'Male 30-34',value:'B01001_012E'},
            {name:'Male 35-39',value:'B01001_013E'},
            {name:'Male 40-44',value:'B01001_014E'},
            {name:'Male 45-49',value:'B01001_015E'},
            {name:'Male 50-54',value:'B01001_016E'},
            {name:'Male 55-59',value:'B01001_017E'},
            {name:'Male 60-61',value:'B01001_018E'},
            {name:'Male 62-64',value:'B01001_019E'},
            {name:'Male 65-66',value:'B01001_020E'},
            {name:'Male 67-69',value:'B01001_021E'},
            {name:'Male 70-74',value:'B01001_022E'},
            {name:'Male 75-79',value:'B01001_023E'},
            {name:'Male 80-84',value:'B01001_024E'},
            {name:'Male 85 over',value:'B01001_025E'},
            {name:'Female Population',value:'B01001_026E'},
            {name:'Female Under 5',value:'B01001_027E'},
            {name:'Female 5-9',value:'B01001_028E'},
            {name:'Female 10-14',value:'B01001_029E'},
            {name:'Female 15-17',value:'B01001_030E'},
            {name:'Female 18-19',value:'B01001_031E'},
            {name:'Female 20',value:'B01001_032E'},
            {name:'Female 21',value:'B01001_033E'},
            {name:'Female 22-24',value:'B01001_034E'},
            {name:'Female 25-29',value:'B01001_035E'},
            {name:'Female 30-34',value:'B01001_036E'},
            {name:'Female 35-39',value:'B01001_037E'},
            {name:'Female 40-44',value:'B01001_038E'},
            {name:'Female 45-49',value:'B01001_039E'},
            {name:'Female 50-54',value:'B01001_040E'},
            {name:'Female 55-59',value:'B01001_041E'},
            {name:'Female 60-61',value:'B01001_042E'},
            {name:'Female 62-64',value:'B01001_043E'},
            {name:'Female 65-66',value:'B01001_044E'},
            {name:'Female 67-69',value:'B01001_045E'},
            {name:'Female 70-74',value:'B01001_046E'},
            {name:'Female 75-79',value:'B01001_047E'},
            {name:'Female 80-84',value:'B01001_048E'},
            {name:'Female 85 over',value:'B01001_049E'}

        ]
    },

    B16001: {
        name: 'Language Spoken at Home by Ability to Speak English',
        variables : [
            {name:'Spanish or Spanish Creole Speak English very well',value:'B16001_004E'},
            {name:'Spanish or Spanish Creole Speak English Less than very well',value:'B16001_005E'},
            {name:'French (incl. Patois,Cajun) Speak English very well',value:'B16001_007E'},
            {name:'French (incl. Patois,Cajun) Speak English Less than very well',value:'B16001_008E'},
            {name:'French Creole Speak English very well',value:'B16001_010E'},
            {name:'French Creole Speak English Less than very well',value:'B16001_011E'},
            {name:'Italian Speak English very well',value:'B16001_013E'},
            {name:'Italian Speak English Less than very well',value:'B16001_014E'},
            {name:'Portuguese or Portuguese Creole Speak English very well',value:'B16001_016E'},
            {name:'Portuguese or Portuguese Creole Speak English Less than very well',value:'B16001_017E'},
            {name:'German Speak English very well',value:'B16001_019E'},
            {name:'German Speak English Less than very well',value:'B16001_020E'},
            {name:'Yiddish Speak English very well',value:'B16001_022E'},
            {name:'Yiddish Speak English Less than very well',value:'B16001_023E'},
            {name:'Tagalog Speak English very well ',value:'B16001_094E'},
            {name:'Tagalog Speak English Less than very well ',value:'B16001_095E'},
            {name:'Greek Speak English very well',value:'B16001_030E'},
            {name:'Greek Speak English Less than very well',value:'B16001_031E'},
            {name:'Russian Speak English very well',value:'B16001_034E'},
            {name:'Russian Speak English Less than very well',value:'B16001_035E'},
            {name:'Polish Speak English very well',value:'B16001_037E'},
            {name:'Polish Speak English Less than very well',value:'B16001_038E'},
            {name:'Serbo-Croatian Speak English very well',value:'B16001_040E'},
            {name:'Serbo-Croatian Speak English Less than very well',value:'B16001_041E'},
            {name:'Other Salvic Languages Speak English very well',value:'B16001_043E'},
            {name:'Other Salvic Languages Speak English Less than very well',value:'B16001_044E'},
            {name:'Other Asian Languages Speak English very well ',value:'B16001_091E'},
            {name:'Other Asian Languages Speak English Less than very well ',value:'B16001_092E'},
            {name:'Persian Speak English very well',value:'B16001_049E'},
            {name:'Persian Speak English Less than very well',value:'B16001_050E'},
            {name:'Gujarati Speak English very well',value:'B16001_052E'},
            {name:'Gujarati Speak English Less than very well',value:'B16001_053E'},
            {name:'Hindi Speak English very well',value:'B16001_055E'},
            {name:'Hindi Speak English Less than very well',value:'B16001_056E'},
            {name:'Urdu Speak English very well',value:'B16001_058E'},
            {name:'Urdu Speak English Less than very well',value:'B16001_059E'},
            {name:'Other Indic languages Speak English very well',value:'B16001_061E'},
            {name:'Other Indic languages Speak English Less than very well',value:'B16001_062E'},
            {name:'Other Indo-European languages Speak English very well',value:'B16001_064E'},
            {name:'Other Indo-European languages Speak English Less than very well',value:'B16001_065E'},
            {name:'Chinese Speak English very well',value:'B16001_067E'},
            {name:'Chinese Speak English Less than very well',value:'B16001_068E'},
            {name:'Japanese Speak English very well',value:'B16001_070E'},
            {name:'Japanese Speak English Less than very well',value:'B16001_071E'},
            {name:'Korean Speak English very well',value:'B16001_073E'},
            {name:'Korean Speak English Less than very well',value:'B16001_074E'},
            {name:'Mon-Khmer Cambodian Speak English very well',value:'B16001_076E'},
            {name:'Mon-Khmer Cambodian Speak English Less than very well',value:'B16001_077E'},
        ]
    },
    B19013:{
        name:'Median Household Income',
        variables:[
            {name:'Household income',value:'B19013_001E'}
        ]
    },
    B23008: {
        name: 'Own children under 18 years in families and subfamilies',
        variables : [
            {name: 'Total',value:'B23008_001E'}, // 0
            {name: 'Under 6 years',value:'B23008_002E'},
            {name: 'Living with two parents',value:'B23008_003E'}, //2
            {name: 'Both Parents in labor force',value:'B23008_004E'},
            {name: 'Father only in labor force',value:'B23008_005E'},
            {name: 'Mother only in labor force',value:'B23008_006E'},
            {name: 'Neither parent in labor force',value:'B23008_007E'},
            {name: 'Living with one parent',value:'B23008_008E'},
            {name: 'Living with father',value:'B23008_009E'}, // 8
            {name: 'In labor force',value:'B23008_010E'},
            {name: 'Not in labor force',value:'B23008_011E'},
            {name: 'Living with mother',value:'B23008_012E'}, // 11
            {name: 'In labor force',value:'B23008_013E'},
            {name: 'Not in labor force',value:'B23008_014E'},
            {name: '6 to 17 years',value:'B23008_015E'},
            {name: 'Living with two parents',value:'B23008_016E'}, //15
            {name: 'Both Parents in labor force',value:'B23008_017E'},
            {name: 'Father only in labor force',value:'B23008_018E'},
            {name: 'Mother only in labor force',value:'B23008_019E'},
            {name: 'Neither parent in labor force',value:'B23008_020E'},
            {name: 'Living with one parent',value:'B23008_021E'},
            {name: 'Living with father',value:'B23008_022E'}, // 21
            {name: 'In labor force',value:'B23008_023E'},
            {name: 'Not in labor force',value:'B23008_024E'},
            {name: 'Living with mother',value:'B23008_025E'}, // 24
            {name: 'In labor force',value:'B23008_026E'},
            {name: 'Not in labor force',value:'B23008_027E'},

        ]
    },
    B25002:{
        name:'Occupancy Status',
        variables: [
            {name:'Total',value:'B25002_001E'},
            {name:'Occupied Units',value:'B25002_002E'},
            {name:'Vacant Units',value:'B25002_003E'}
        ]
    },
    B17001:{
        name:'Poverty Status by Sex by Age',
        variables:[
            // {name:'Income in the past 12 months below poverty level',value:'B17001_002E'},
            // {name:'Total',value:'B17001_001E'},
            // {name:'Total Male', value:'B17001_003E'},
            {name:'Male Under 5',value:'B17001_004E'},
            {name:'Male 5 years',value:'B17001_005E'},
            {name:'Male 6-11 years',value:'B17001_006E'},
            {name:'Male 12-14 years',value:'B17001_007E'},
            {name:'Male 15 years',value:'B17001_008E'},
            {name:'Male 16-17 years',value:'B17001_009E'},
            {name:'Male 18-24 years',value:'B17001_010E'},
            {name:'Male 25-34 years',value:'B17001_011E'},
            {name:'Male 35-44 years',value:'B17001_012E'},
            {name:'Male 45-54 years',value:'B17001_013E'},
            {name:'Male 55-64 years',value:'B17001_014E'},
            {name:'Male 65-74 years',value:'B17001_015E'},
            {name:'Male 75 years over',value:'B17001_016E'},
            // {name:'Total Female', value:'B17001_017E'},
            {name:'Female Under 5',value:'B17001_018E'},
            {name:'Female 5 years',value:'B17001_019E'},
            {name:'Female 6-11 years',value:'B17001_020E'},
            {name:'Female 12-14 years',value:'B17001_021E'},
            {name:'Female 15 years',value:'B17001_022E'},
            {name:'Female 16-17 years',value:'B17001_023E'},
            {name:'Female 18-24 years',value:'B17001_024E'},
            {name:'Female 25-34 years',value:'B17001_025E'},
            {name:'Female 35-44 years',value:'B17001_026E'},
            {name:'Female 45-54 years',value:'B17001_027E'},
            {name:'Female 55-64 years',value:'B17001_028E'},
            {name:'Female 65-74 years',value:'B17001_029E'},
            {name:'Female 75 years over',value:'B17001_030E'},
            //--------------------------------------------------------------------------------------
            // {name:'Income in the past months above or at Poverty level',value:'B17001_31E'},
            // {name:'Total Male', value:'B17001_032E'},
            {name:'Male Under 5',value:'B17001_033E'},
            {name:'Male 5 years',value:'B17001_034E'},
            {name:'Male 6-11 years',value:'B17001_035E'},
            {name:'Male 12-14 years',value:'B17001_036E'},
            {name:'Male 15 years',value:'B17001_037E'},
            {name:'Male 16-17 years',value:'B17001_038E'},
            {name:'Male 18-24 years',value:'B17001_039E'},
            {name:'Male 25-34 years',value:'B17001_040E'},
            {name:'Male 35-44 years',value:'B17001_041E'},
            {name:'Male 45-54 years',value:'B17001_042E'},
            {name:'Male 55-64 years',value:'B17001_043E'},
            {name:'Male 65-74 years',value:'B17001_044E'},
            {name:'Male 75 years over',value:'B17001_045E'},
            // {name:'Total Female', value:'B17001_046E'},
            {name:'Female Under 5',value:'B17001_047E'},
            {name:'Female 5 years',value:'B17001_048E'},
            {name:'Female 6-11 years',value:'B17001_049E'},
            {name:'Female 12-14 years',value:'B17001_050E'},
            {name:'Female 15 years',value:'B17001_051E'},
            {name:'Female 16-17 years',value:'B17001_052E'},
            {name:'Female 18-24 years',value:'B17001_053E'},
            {name:'Female 25-34 years',value:'B17001_054E'},
            {name:'Female 35-44 years',value:'B17001_055E'},
            {name:'Female 45-54 years',value:'B17001_056E'},
            {name:'Female 55-64 years',value:'B17001_057E'},
            {name:'Female 65-74 years',value:'B17001_058E'},
            {name:'Female 75 years over',value:'B17001_059E'},



        ]
    },
    B15003:{
        name:'Educational Attainment',
        variables:[
            // {name:'Total',value:'B15003_001E'},
            {name:'No schooling completed',value:'B15003_002E'},
            {name:'Nursery School',value:'B15003_003E'},
            {name:'Kindergarten',value:'B15003_004E'},
            {name:'1st grade',value:'B15003_005E'},
            {name:'2nd grade',value:'B15003_006E'},
            {name:'3rd grade',value:'B15003_007E'},
            {name:'4th grade',value:'B15003_008E'},
            {name:'5th grade',value:'B15003_009E'},
            {name:'6th grade',value:'B15003_010E'},
            {name:'7th grade',value:'B15003_011E'},
            {name:'8th grade',value:'B15003_012E'},
            {name:'9th grade',value:'B15003_013E'},
            {name:'10th grade',value:'B15003_014E'},
            {name:'11th grade',value:'B15003_015E'},
            {name:'12th grade or no diploma',value:'B15003_016E'},
            {name:'Regular High School diploma',value:'B15003_017E'}, // i =16
            {name:'GED or alternative credential',value:'B15003_018E'},
            {name:'Some college less than 1 year',value:'B15003_019E'},
            {name:'Some college,1 or more years,no degree',value:'B15003_020E'},
            {name:'Associate`s degree',value:'B15003_021E'},
            {name:'Bachelor`s degree',value:'B15003_022E'},
            {name:'Master`s degree',value:'B15003_023E'},
            {name:'Professional School degree',value:'B15003_024E'},
            {name:'Doctorate degree',value:'B15003_025E'}
        ]
    },
    B19119: {
        name: 'Median Family Income by Family Size',
        variables: [
            {name: 'Total', value: 'B19119_001E'},
            {name: '2-person families', value: 'B19119_002E'},
            {name: '3-person families', value: 'B19119_003E'},
            {name: '4-person families', value: 'B19119_004E'},
            {name: '5-person families', value: 'B19119_005E'},
            {name: '6-person families', value: 'B19119_006E'},
            {name: '7-person families', value: 'B19119_007E'}

        ]
    },
    B19013A:{
        name: 'Median household income, White',
        variables :[
            {name: ' White ', value:'B19013A_001E'}
        ]
    },
    B19013B:{
        name: 'Median household income, Black or African American',
        variables :[
            {name: 'Black or African American', value:'B19013B_001E'}
        ]

    },
    B19013C: {
        name: 'Median household income, American Indian or Alaska Native',
        variables :[
            {name: 'American Indian or Alaska Native', value:'B19013C_001E'}
        ]
    },
    B19013D: {
        name: 'Median household income, Asian',
        variables : [
            {name: 'Asian', value:'B19013D_001E'}
        ]
    },
    B19013E: {
        name: 'Median household income, Native Hawaiian and Other Pacific Islander',
        variables :[
            {name:'Native Hawaiian and Other Pacific Islander',value:'B19013E_001E'}
        ]
    },
    B19013F: {
        name: 'Median household income, Some Other Race',
        variables :[
            {name:'Some Other Race',value:'B19013F_001E'}
        ]
    },
    B19013G: {
        name: 'Median household income, Two or more races',
        variables : [
            {name:'Two or more races',value:'B19013G_001E'}
        ]
    },
    B19013H: {
        name: 'Median household income, White, Not Hispanic or Latino',
        variables :[
            {name:'White, Not Hispanic or Latino',value:'B19013H_001E'}
        ]
    },
    B19013I: {
        name: 'Median household income, Hispanic or Latino',
        variables :[
            {name:'Hispanic or Latino',value:'B19013I_001E'}
        ]
    },
    B21001 : {
        name: 'Civilian Population 18 Years and Over',
        variables :[
            {name:'Total',value:'B21001_001E'},
            {name:'Total veteran',value:'B21001_002E'},
            {name:'Total non veteran',value:'B21001_003E'},
            {name:'Total Male',value:'B21001_004E'},
            {name:'Total Male veteran',value:'B21001_005E'},
            {name:'Total Male non veteran',value:'B21001_006E'},
            {name:'Total Male 18-34 years',value:'B21001_007E'},
            {name:'Male 18-34 years veteran',value:'B21001_008E'},
            {name:'Male 18-34 years non veteran',value:'B21001_009E'},
            {name:'Total Male 35-54 years',value:'B21001_010E'},
            {name:'Male 35-54 years veteran',value:'B21001_011E'},
            {name:'Male 35-54 years non veteran',value:'B21001_012E'},
            {name:'Total Male 55-64 years',value:'B21001_013E'},
            {name:'Male 55-64 years veteran',value:'B21001_014E'},
            {name:'Male 55-64 years non veteran',value:'B21001_015E'},
            {name:'Total Male 65-74 years',value:'B21001_016E'},
            {name:'Male 65-74 years veteran',value:'B21001_017E'},
            {name:'Male 65-74 years non veteran',value:'B21001_018E'},
            {name:'Total Male 75 years over',value:'B21001_019E'},
            {name:'Male 75 years over veteran',value:'B21001_020E'},
            {name:'Male 75 years over non veteran',value:'B21001_021E'},
            {name:'Total Female',value:'B21001_022E'},
            {name:'Total Female veteran',value:'B21001_023E'},
            {name:'Total Female non veteran',value:'B21001_024E'},
            {name:'Total Female 18-34 years',value:'B21001_025E'},
            {name:'Female 18-34 years veteran',value:'B21001_026E'},
            {name:'Female 18-34 years non veteran',value:'B21001_027E'},
            {name:'Total Female 35-54 years',value:'B21001_028E'},
            {name:'Female 35-54 years veteran',value:'B21001_029E'},
            {name:'Female 35-54 years non veteran',value:'B21001_030E'},
            {name:'Total Female 55-64 years',value:'B21001_031E'},
            {name:'Female 55-64 years veteran',value:'B21001_032E'},
            {name:'Female 55-64 years non veteran',value:'B21001_033E'},
            {name:'Total Female 65-74 years',value:'B21001_034E'},
            {name:'Female 65-74 years veteran',value:'B21001_035E'},
            {name:'Female 65-74 years non veteran',value:'B21001_036E'},
            {name:'Total Female 75 years over',value:'B21001_037E'},
            {name:'Female 75 years over veteran',value:'B21001_038E'},
            {name:'Female 75 years over non veteran',value:'B21001_039E'}

        ]
    },
    B25004: {
        name: 'Vacancy Status',
        variables: [
            {name: 'Total',value:'B25004_001E'},
            {name: 'For rent',value:'B25004_002E'},
            {name: 'Rented,not occupied',value:'B25004_003E'},
            {name: 'For sale only',value:'B25004_004E'},
            {name: 'Sold,not occupied',value:'B25004_005E'},
            {name:'For seasonal, recreational, or occasional use',value:'B25004_006E'},
            {name:'For migrant workers',value:'B25004_007E'},
            {name:'Other vacant',value:'B25004_008E'}
        ]
    },
    B25118:{
        name:'Occupied Housing Units',
        variables: [
            {name:'Total',value:'B25118_001E'},
            {name:'Owner Occupied',value:'B25118_002E'},
            {name:'Less than $5,000',value:'B25118_003E'},
            {name:'$5k-$9,999',value:'B25118_004E'},
            {name:'$10k-$14,999',value:'B25118_005E'},
            {name:'$15k-$19,999',value:'B25118_006E'},
            {name:'$20k-$24,999',value:'B25118_007E'},
            {name:'$25k-$34,999',value:'B25118_008E'},
            {name:'$35k-$49,999',value:'B25118_009E'},
            {name:'$50k-$74,999',value:'B25118_010E'},
            {name:'$75k-$99,999',value:'B25118_011E'},
            {name:'$100k-$149,999',value:'B25118_012E'},
            {name:'$150k or more',value:'B25118_013E'},
            {name:'Renter Occupied',value:'B25118_014E'},
            {name:'Less than $5,000',value:'B25118_015E'},
            {name:'$5k-$9,999',value:'B25118_016E'},
            {name:'$10k-$14,999',value:'B25118_017E'},
            {name:'$15k-$19,999',value:'B25118_018E'},
            {name:'$20k-$24,999',value:'B25118_019E'},
            {name:'$25k-$34,999',value:'B25118_020E'},
            {name:'$35k-$49,999',value:'B25118_021E'},
            {name:'$50k-$74,999',value:'B25118_022E'},
            {name:'$75k-$99,999',value:'B25118_023E'},
            {name:'$100k-$149,999',value:'B25118_024E'},
            {name:'$150k or more',value:'B25118_025E'}
        ]
    },
    B25087:{
        name :'Owner-Occupied Housing Units',
        variables:[
            // {name:'Total',value:'B25087_001E'},
            {name:'Housing units with a mortgage',value:'B25087_002E'},
            {name:'Less than $200',value:'B25087_003E'},
            {name:'$200-$299',value:'B25087_004E'},
            {name:'$300-$399',value:'B25087_005E'},
            {name:'$400-$499',value:'B25087_006E'},
            {name:'$500-$599',value:'B25087_007E'},
            {name:'$600-$699',value:'B25087_008E'},
            {name:'$700-$799',value:'B25087_009E'},
            {name:'$800-$899',value:'B25087_010E'},
            {name:'$900-$999',value:'B25087_011E'},
            {name:'$1,000-$1,249',value:'B25087_012E'},
            {name:'$1,250-$1,499',value:'B25087_013E'},
            {name:'$1,500-$1,999',value:'B25087_014E'},
            {name:'$2,000-$2,499',value:'B25087_015E'},
            {name:'$2,500-$2,999',value:'B25087_016E'},
            {name:'$3,000-$3,499',value:'B25087_017E'},
            {name:'$3,500-$3,999',value:'B25087_018E'},
            {name:'$4,000 or more',value:'B25087_019E'},
            {name:'Housing units without a mortgage',value:'B25087_020E'},
            {name:'Less than $100',value:'B25087_021E'},
            {name:'$100-$149',value:'B25087_022E'},
            {name:'$150-$199',value:'B25087_023E'},
            {name:'$200-$249',value:'B25087_024E'},
            {name:'$250-$299',value:'B25087_025E'},
            {name:'$300-$349',value:'B25087_026E'},
            {name:'$350-$399',value:'B25087_027E'},
            {name:'$400-$499',value:'B25087_028E'},
            {name:'$500-$599',value:'B25087_029E'},
            {name:'$600-$699',value:'B25087_030E'},
            {name:'$700-$799',value:'B25087_031E'},
            {name:'$800-$899',value:'B25087_032E'},
            {name:'$900-$999',value:'B25087_033E'},
            {name:'$1000-$1099',value:'B25087_034E'},
            {name:'$1100-$1199',value:'B25087_035E'},
            {name:'$1200-$1299',value:'B25087_036E'},
            {name:'$1300-$1399',value:'B25087_037E'},
            {name:'$1400-$1499',value:'B25087_038E'},
            {name:'$1500 or more',value:'B25087_039E'}
        ]
    },

    B14003:{
        name:'Sex by School Enrollment by Type of School by Age',
        variables:[
            // {name:'Total',value:'B14003_001E'},
            // {name:'Male',value:'B14003_002E'},
            // {name:'Enrolled in public school',value:'B14003_003E'},
            {name:'ages 3 and 4, enrolled in school',value:'B14003_004E'},
            {name:'ages 5 to 9, enrolled in school',value:'B14003_005E'},
            {name:'ages 10 to 14, enrolled in school',value:'B14003_006E'},
            {name:'ages 15 to 17, enrolled in school',value:'B14003_007E'},
            {name:'ages 18 and 19, enrolled in school',value:'B14003_008E'},
            {name:'ages 20 to 24, enrolled in school',value:'B14003_009E'},
            {name:'ages 25 to 34, enrolled in school',value:'B14003_010E'},
            {name:'ages 35 and over, enrolled in school',value:'B14003_011E'},
            // {name:'ages Enrolled in private school',value:'B14003_012E'},
            {name:'ages 3 and 4, enrolled in private school',value:'B14003_013E'},
            {name:'ages 5 to 9, enrolled in private school',value:'B14003_014E'},
            {name:'ages 10 to 14, enrolled in private school',value:'B14003_015E'},
            {name:'ages 15 to 17, enrolled in private school',value:'B14003_016E'},
            {name:'ages 18 and 19, enrolled in private school',value:'B14003_017E'},
            {name:'ages 20 to 24, enrolled in private school',value:'B14003_018E'},
            {name:'ages 25 to 34, enrolled in private school',value:'B14003_019E'},
            {name:'ages 35 and over, enrolled in private school',value:'B14003_020E'},
            // {name:'Not enrolled in school',value:'B14003_021E'},
            {name:'ages 3 and 4, not enrolled in school',value:'B14003_022E'},
            {name:'ages 5 to 9, not enrolled in school',value:'B14003_023E'},
            {name:'ages 10 to 14, not enrolled in school',value:'B14003_024E'},
            {name:'ages 15 to 17, not enrolled in school',value:'B14003_025E'},
            {name:'ages 18 and 19, not enrolled in school',value:'B14003_026E'},
            {name:'ages 20 to 24, not enrolled in school',value:'B14003_027E'},
            {name:'ages 25 to 34, not enrolled in school',value:'B14003_028E'},
            {name:'ages 35 and over, not enrolled in school',value:'B14003_029E'},
            // {name:'Female',value:'B14003_030E'},
            // {name:'Enrolled in public school',value:'B14003_031E'},
            {name:'3 and 4 years',value:'B14003_032E'},
            {name:'5 to 9 years',value:'B14003_033E'},
            {name:'10 to 14 years',value:'B14003_034E'},
            {name:'15 to 17 years',value:'B14003_035E'},
            {name:'18 and 19 years',value:'B14003_036E'},
            {name:'20 to 24 years',value:'B14003_037E'},
            {name:'25 to 34 years',value:'B14003_038E'},
            {name:'35 years and over',value:'B14003_039E'},
            // {name:'Enrolled in private school',value:'B14003_040E'},
            {name:'3 and 4 years',value:'B14003_041E'},
            {name:'5 to 9 years',value:'B14003_042E'},
            {name:'10 to 14 years',value:'B14003_043E'},
            {name:'15 to 17 years',value:'B14003_044E'},
            {name:'18 and 19 years',value:'B14003_045E'},
            {name:'20 to 24 years',value:'B14003_046E'},
            {name:'25 to 34 years',value:'B14003_047E'},
            {name:'35 years and over',value:'B14003_048E'},
            // {name:'Not enrolled in school',value:'B14003_049E'},
            {name:'3 and 4 years',value:'B14003_050E'},
            {name:'5 to 9 years',value:'B14003_051E'},
            {name:'10 to 14 years',value:'B14003_052E'},
            {name:'15 to 17 years',value:'B14003_053E'},
            {name:'18 and 19 years',value:'B14003_054E'},
            {name:'20 to 24 years',value:'B14003_055E'},
            {name:'25 to 34 years',value:'B14003_056E'},
            {name:'35 years and over',value:'B14003_057E'}

        ]
    },
    B25091:{
        name:'Mortgage Status by Selected Monthly Owner Costs as a Percentage of Household Income',
        variables:[
            // {name:'Total',value:'B25091_001E'},
            // {name:'Total',value:'B25091_002E'},
            {name:'Less than 10.0 percent',value:'B25091_003E'},
            {name:'10.0 to 14.9 percent',value:'B25091_004E'},
            {name:'15.0 to 19.9 percent',value:'B25091_005E'},
            {name:'20.0 to 24.9 percent',value:'B25091_006E'},
            {name:'25.0 to 29.9 percent',value:'B25091_007E'},
            {name:'30.0 to 34.9 percent',value:'B25091_008E'},
            {name:'35.0 to 39.9 percent',value:'B25091_009E'},
            {name:'40.0 to 49.9 percent',value:'B25091_010E'},
            {name:'50.0 percent or more',value:'B25091_011E'},
            // {name:'not computed',value:'B25091_012E'},
            // {name:'Housing units without a mortgage',value:'B25091_013E'},
            {name:'Less than 10.0 percent',value:'B25091_014E'},
            {name:'10.0 to 14.9 percent',value:'B25091_015E'},
            {name:'15.0 to 19.9 percent',value:'B25091_016E'},
            {name:'20.0 to 24.9 percent',value:'B25091_017E'},
            {name:'25.0 to 29.9 percent',value:'B25091_018E'},
            {name:'30.0 to 34.9 percent',value:'B25091_019E'},
            {name:'35.0 to 39.9 percent',value:'B25091_020E'},
            {name:'40.0 to 49.9 percent',value:'B25091_021E'},
            {name:'50.0 percent or more',value:'B25091_022E'},
            // {name:'not computed',value:'B25091_023E'}
        ]
    }


}
/*
B14002:{
        name:'Sex by School Enrollment by Level of School by Type of School',
        variables:[
            {name:'Total',value:'B14002_001E'},
            {name:'Male',value:'B14002_002E'},
            {name:'Enrolled in school',value:'B14002_003E'},
            {name:'Enrolled in nursery school,preschool',value:'B14002_004E'},
            {name:'Public School',value:'B14002_005E'},
            {name:'Private School',value:'B14002_006E'},
            {name:'Enrolled in kindergarten',value:'B14002_007E'},
            {name:'Public School',value:'B14002_008E'},
            {name:'Private School',value:'B14002_009E'},
            {name:'Enrolled in grade 1 to grade 4',value:'B14002_010E'},
            {name:'Public School',value:'B14002_011E'},
            {name:'Private School',value:'B14002_012E'},
            {name:'Enrolled in grade 5 to grade 8',value:'B14002_013E'},
            {name:'Public School',value:'B14002_014E'},
            {name:'Private School',value:'B14002_015E'},
            {name:'Enrolled in grade 9 to grade 12',value:'B14002_016E'},
            {name:'Public School',value:'B14002_017E'},
            {name:'Private School',value:'B14002_018E'},
            {name:'Enrolled in college undergraduate years',value:'B14002_019E'},
            {name:'Public School',value:'B14002_020E'},
            {name:'Private School',value:'B14002_021E'},
            {name:'Enrolled in graduate school or professional school',value:'B14002_022E'},
            {name:'Public School',value:'B14002_023E'},
            {name:'Private School',value:'B14002_024E'},
            {name:'Not enrolled in school',value:'B14002_025E'},
            {name:'Female',value:'B14002_026E'},
            {name:'Enrolled in school',value:'B14002_027E'},
            {name:'Enrolled in nursery school,preschool',value:'B14002_028E'},
            {name:'Public School',value:'B14002_029E'},
            {name:'Private School',value:'B14002_030E'},
            {name:'Enrolled in kindergarten',value:'B14002_031E'},
            {name:'Public School',value:'B14002_032E'},
            {name:'Private School',value:'B14002_033E'},
            {name:'Enrolled in grade 1 to grade 4',value:'B14002_034E'},
            {name:'Public School',value:'B14002_035E'},
            {name:'Private School',value:'B14002_036E'},
            {name:'Enrolled in grade 5 to grade 8',value:'B14002_037E'},
            {name:'Public School',value:'B14002_038E'},
            {name:'Private School',value:'B14002_039E'},
            {name:'Enrolled in grade 9 to grade 12',value:'B14002_040E'},
            {name:'Public School',value:'B14002_041E'},
            {name:'Private School',value:'B14002_042E'},
            {name:'Enrolled in college undergraduate years',value:'B14002_043E'},
            {name:'Public School',value:'B14002_044E'},
            {name:'Private School',value:'B14002_045E'},
            {name:'Enrolled in graduate school or professional school',value:'B14002_046E'},
            {name:'Public School',value:'B14002_047E'},
            {name:'Private School',value:'B14002_048E'},
            {name:'Not enrolled in school',value:'B14002_049E'}

        ]
    }

B21001 : {
        name: 'Civilian Population 18 Years and Over',
        variables :[
            {name:'Total',value:'B21001_001E'},
            {name:'Total veteran',value:'B21001_002E'},
            {name:'Total non veteran',value:'B21001_003E'},
            {name:'Total Male',value:'B21001_004E'},
            {name:'Total Male veteran',value:'B21001_005E'},
            {name:'Total Male non veteran',value:'B21001_006E'},
            {name:'Total Male 18-34 years',value:'B21001_007E'},
            {name:'Male 18-34 years veteran',value:'B21001_008E'},
            {name:'Male 18-34 years non veteran',value:'B21001_009E'},
            {name:'Total Male 35-54 years',value:'B21001_010E'},
            {name:'Male 35-54 years veteran',value:'B21001_011E'},
            {name:'Male 35-54 years non veteran',value:'B21001_012E'},
            {name:'Total Male 55 to 64 years',value:'B21001_013E'},
            {name:'Male 55 to 64 years veteran',value:'B21001_014E'},
            {name:'Male 55 to 64 years non veteran',value:'B21001_015E'},
            {name:'Total Male 65 to 74 years',value:'B21001_016E'},
            {name:'Male 65 to 74 years veteran',value:'B21001_017E'},
            {name:'Male 65 to 74 years non veteran',value:'B21001_018E'},
            {name:'Total Male 75 years and over',value:'B21001_019E'},
            {name:'Male 75 years and over veteran',value:'B21001_020E'},
            {name:'Male 75 years and over non veteran',value:'B21001_021E'},
            {name:'Total Female',value:'B21001_022E'},
            {name:'Total Female veteran',value:'B21001_023E'},
            {name:'Total Female non veteran',value:'B21001_024E'},
            {name:'Total Female 18-34 years',value:'B21001_025E'},
            {name:'Female 18-34 years veteran',value:'B21001_026E'},
            {name:'Female 18-34 years non veteran',value:'B21001_027E'},
            {name:'Total Female 35-54 years',value:'B21001_028E'},
            {name:'Female 35-54 years veteran',value:'B21001_029E'},
            {name:'Female 35-54 years non veteran',value:'B21001_030E'},
            {name:'Total Female 55 to 64 years',value:'B21001_031E'},
            {name:'Female 55 to 64 years veteran',value:'B21001_032E'},
            {name:'Female 55 to 64 years non veteran',value:'B21001_033E'},
            {name:'Total Female 65 to 74 years',value:'B21001_034E'},
            {name:'Female 65 to 74 years veteran',value:'B21001_035E'},
            {name:'Female 65 to 74 years non veteran',value:'B21001_036E'},
            {name:'Total Female 75 years and over',value:'B21001_037E'},
            {name:'Female 75 years and over veteran',value:'B21001_038E'},
            {name:'Female 75 years and over non veteran',value:'B21001_039E'}

        ]
    }


B01001: { // Added a new one for graphs
        name: 'Sex by Age',
        variables: [
            {name:'Total Population',value:'B01001_001E'},
            {name:'Male Population',value:'B01001_002E'},
            {name:'Male Under 5',value:'B01001_003E'},
            {name:'Male 5-9',value:'B01001_004E'},
            {name:'Male 10-14',value:'B01001_005E'},
            {name:'Male 15-17',value:'B01001_006E'},
            {name:'Male 18-19',value:'B01001_007E'},
            {name:'Male 20',value:'B01001_008E'},
            {name:'Male 21',value:'B01001_009E'},
            {name:'Male 22-24',value:'B01001_010E'},
            {name:'Male 25-29',value:'B01001_011E'},
            {name:'Male 30-34',value:'B01001_012E'},
            {name:'Male 35-39',value:'B01001_013E'},
            {name:'Male 40-44',value:'B01001_014E'},
            {name:'Male 45-49',value:'B01001_015E'},
            {name:'Male 50-54',value:'B01001_016E'},
            {name:'Male 55-59',value:'B01001_017E'},
            {name:'Male 60-61',value:'B01001_018E'},
            {name:'Male 62-64',value:'B01001_019E'},
            {name:'Male 65-66',value:'B01001_020E'},
            {name:'Male 67-69',value:'B01001_021E'},
            {name:'Male 70-74',value:'B01001_022E'},
            {name:'Male 75-79',value:'B01001_023E'},
            {name:'Male 80-84',value:'B01001_024E'},
            {name:'Male 85 over',value:'B01001_025E'},
            //-------------- starts------------------
            {name:'Female Population',value:'B01001_026E'},
            {name:'Female Under 5',value:'B01001_027E'},
            {name:'Female 5-9',value:'B01001_028E'},
            {name:'Female 10-14',value:'B01001_029E'},
            {name:'Female 15-17',value:'B01001_030E'},
            {name:'Female 18-19',value:'B01001_031E'},
            {name:'Female 20',value:'B01001_032E'},
            {name:'Female 21',value:'B01001_033E'},
            {name:'Female 22-24',value:'B01001_034E'},
            {name:'Female 25-29',value:'B01001_035E'},
            {name:'Female 30-34',value:'B01001_036E'},
            {name:'Female 35-39',value:'B01001_037E'},
            {name:'Female 40-44',value:'B01001_038E'},
            {name:'Female 45-49',value:'B01001_039E'},
            {name:'Female 50-54',value:'B01001_040E'},
            {name:'Female 55-59',value:'B01001_041E'},
            {name:'Female 60-61',value:'B01001_042E'},
            {name:'Female 62-64',value:'B01001_043E'},
            {name:'Female 65-66',value:'B01001_044E'},
            {name:'Female 67-69',value:'B01001_045E'},
            {name:'Female 70-74',value:'B01001_046E'},
            {name:'Female 75-79',value:'B01001_047E'},
            {name:'Female 80-84',value:'B01001_048E'},
            {name:'Female 85 over',value:'B01001_049E'}

        ]
    },
    B01002: {
        name: 'Median Age by Sex',
        variables: [
            {name:'B',value:'B01002_001E'},
            {name:'C',value:'B01002_002E'},
            {name:'D',value:'B01002_003E'}
        ]
    },



        name: 'Employment Status',
        variables:[
            {name:'R',value:'B23025_001E'},
            {name:'S',value:'B23025_002E'},
            {name:'T',value:'B23025_003E'},
            {name:'U',value:'B23025_004E'},
            {name:'V',value:'B23025_005E'},
            {name:'W',value:'B23025_006E'},
            {name:'X',value:'B23025_007E'}
        ]
    }
    ,
    C02003:{
        name: 'Ethinic Population by Race',
        variables:[
            'C02003_001E',
            'C02003_002E',
            'C02003_003E',
            'C02003_004E',
            'C02003_005E',
            'C02003_006E',
            'C02003_007E',
            'C02003_008E',
            'C02003_009E',
            'C02003_010E',
            'C02003_011E',
            'C02003_012E'
        ]
    }
    B19083:{
        name:'Gini Index of Income Inequality',
        variables:[
            'B19083_001E'
        ]
    },

    B19025:{
        name:'Aggregate Household Income',
        variables:[
            'B19025_001E'
        ]
    },
    B19301:{
        name:'Per Capita Income',
        variables:[
            'B19301_001E'
        ]
    },
    B23020:{
        name:'Mean Usual Hours Worked for Workers 16 to 64 ',
        variables:[
            'B23020_001E',
            'B23020_002E',
            'B23020_003E'
        ]
    },
    B25003:{
        name: 'Occupied Housing Units Tenure',
        variables:[
            'B25003_001E',
            'B25003_002E',
            'B25003_003E'
        ]
    },
    B08604:{
        name: 'Worker Population',
        variables: [
            'B08604_001E'
        ]
    },
    B15003:{
        name: 'Educational Attainment',
        variables:[
            'B15003_001E'
        ]
    },
    B08301:{
        name: 'Means of Transportation to Work',
        variables:[
            'B08301_001E',
            'B08301_002E',
            'B08301_003E',
            'B08301_004E',
            'B08301_005E',
            'B08301_006E',
            'B08301_007E',
            'B08301_008E',
            'B08301_009E',
            'B08301_010E',
            'B08301_011E',
            'B08301_012E',
            'B08301_013E',
            'B08301_014E',
            'B08301_015E',
            'B08301_016E',
            'B08301_017E',
            'B08301_018E',
            'B08301_019E',
            'B08301_020E',
            'B08301_021E'
        ]
    },
    B08303:{
        name: 'Travel Time to Work',
        variables:[
            'B08303_001E',
            'B08303_002E',
            'B08303_003E',
            'B08303_004E',
            'B08303_005E',
            'B08303_006E',
            'B08303_007E',
            'B08303_008E',
            'B08303_009E',
            'B08303_010E',
            'B08303_011E',
            'B08303_012E',
            'B08303_013E'
        ]
    },

    B25077:{
        name: 'Housing Units Median Value',
        variables:[
            'B25077_001E'
        ]
    },
    B17001:{
        name: 'Poverty Status in the Past 12 Months',
        variables:[
            'B17001_001E',
            'B17001_002E',
            'B17001_003E',
            'B17001_004E',
            'B17001_005E',
            'B17001_006E',
            'B17001_007E',
            'B17001_008E',
            'B17001_009E',
            'B17001_010E',
            'B17001_011E',
            'B17001_012E',
            'B17001_013E',
            'B17001_014E',
            'B17001_015E',
            'B17001_016E',
            'B17001_017E',
            'B17001_018E',
            'B17001_019E',
            'B17001_020E',
            'B17001_021E',
            'B17001_022E',
            'B17001_023E',
            'B17001_024E',
            'B17001_025E',
            'B17001_026E',
            'B17001_027E',
            'B17001_028E',
            'B17001_029E',
            'B17001_030E',
            'B17001_031E',
            'B17001_032E',
            'B17001_033E',
            'B17001_034E',
            'B17001_035E',
            'B17001_036E',
            'B17001_037E',
            'B17001_038E',
            'B17001_039E',
            'B17001_040E',
            'B17001_041E',
            'B17001_042E',
            'B17001_043E',
            'B17001_044E',
            'B17001_045E',
            'B17001_046E',
            'B17001_047E',
            'B17001_048E',
            'B17001_049E',
            'B17001_050E',
            'B17001_051E',
            'B17001_052E',
            'B17001_053E',
            'B17001_054E',
            'B17001_055E',
            'B17001_056E',
            'B17001_057E',
            'B17001_058E',
            'B17001_059E'
        ]
    },
    B11001:{
        name: 'Population by household type',
        variables:[
            'B11001_001E',
            'B11001_002E',
            'B11001_003E',
            'B11001_004E',
            'B11001_005E',
            'B11001_006E',
            'B11001_007E',
            'B11001_008E',
            'B11001_009E'
        ]
    },
    B25002:{
        name: 'Occupied vs. Vacant Housing Units',
        variables:[
            'B25002_001E',
            'B25002_002E',
            'B25002_003E'
        ]
    },
    B21002:{
        name: 'Veterans by wartime service',
        variables:[
            'B21002_001E',
            'B21002_002E',
            'B21002_003E',
            'B21002_004E',
            'B21002_005E',
            'B21002_006E',
            'B21002_007E',
            'B21002_008E',
            'B21002_009E',
            'B21002_010E',
            'B21002_011E',
            'B21002_012E',
            'B21002_013E',
            'B21002_014E',
            'B21002_015E',
            'B21002_016E'
        ]
    },
    B22005A:{
        name: 'Receipt of Food Stamps/SNAP by Race (White)',
        variables:[
            'B22005A_001E',
            'B22005A_002E',
            'B22005A_003E'
        ]

    },
    B22005B:{
        name: 'Receipt of Food Stamps/SNAP by Race (Black or African American Alone)',
        variables:[
            'B22005B_001E',
            'B22005B_002E',
            'B22005B_003E'
        ]
    },
    B22005C:{
        name: 'Receipt of Food Stamps/SNAP by Race (American Indian and Alaska Native)',
        variables:[
            'B22005C_001E',
            'B22005C_002E',
            'B22005C_003E'
        ]
    },
    B22005D:{
        name:'Receipt of Food Stamps/SNAP by Race (Asian)',
        variables:[
            'B22005D_001E',
            'B22005D_002E',
            'B22005D_003E'
        ]
    },
    B22005E:{
        name: 'Receipt of Food Stamps/SNAP by Race (Native Hawaiian and Other Pacific Islander)',
        variables:[
            'B22005E_001E',
            'B22005E_002E',
            'B22005E_003E'
        ]
    },
    B22005F:{
        name: 'Receipt of Food Stamps/SNAP by Race (Some Other Race Alone)',
        variables:[
            'B22005F_001E',
            'B22005F_002E',
            'B22005F_003E'
        ]
    },
    B22005G:{
        name: 'Receipt of Food Stamps/SNAP by Race (Two or More Races)',
        variables:[
            'B22005G_001E',
            'B22005G_002E',
            'B22005G_003E'
        ]
    },
    B22005H:{
        name: 'Receipt of Food Stamps/SNAP by Race (White Alone, Not Hispanic or Latino)',
        variables:[
            'B22005H_001E',
            'B22005H_002E',
            'B22005H_003E'
        ]
    },
    B22005I:{
        name: 'Receipt of Food Stamps/SNAP by Race (Hispanic or Latino)',
        variables:[
            'B22005I_001E',
            'B22005I_002E',
            'B22005I_003E'
        ]
    },
    B05001:{
        name: 'Citizenship status',
        variables:[
            'B05001_001E',
            'B05001_002E',
            'B05001_003E',
            'B05001_004E',
            'B05001_005E',
            'B05001_006E'
        ]
    },
    B19013A:{
        name: 'Median Household Income by Race',
        variables:[
            'B19013A_001E'
        ]
    },
    B19013B:{
        name: 'Median Household Income by Race',
        variables:[
            'B19013B_001E'
        ]
    },
    B19013C:{
        name: 'Median Household Income by Race',
        variable:[
            'B19013C_001E'
        ]
    },
    B19013D:{
        name: 'Median Household Income by Race',
        variables:[
            'B19013D_001E'
        ]
    },
    B19013E:{
        name: 'Median Household Income by Race',
        variables:[
            'B19013E_001E'
        ]
    },
    B19013F:{
        name: 'Median Household Income by Race',
        variables:[
            'B19013F_001E'
        ]
    },
    B19013H:{
        name: 'Median Household Income by Race',
        variables:[
            'B19013H_001E'
        ]
    },
    B19013I:{
        name: 'Median Household Income by Race',
        variables:[
            'B19013I_001E'
        ]
    },
    B05001:{
        name: 'Immigrant/Refugee indicators',
        variables:[
            'B05001_001E',
            'B05001_002E',
            'B05001_003E',
            'B05001_004E',
            'B05001_005E',
            'B05001_006E',
        ]
    },
    B25125:{
        name: 'Tenure by Age of Structure',
        variables:[
            'B25125_001E',
            'B25125_002E',
            'B25125_003E',
            'B25125_004E',
            'B25125_005E',
            'B25125_006E',
            'B25125_007E',
            'B25125_008E',
            'B25125_009E',
            'B25125_010E',
            'B25125_011E',
            'B25125_012E',
            'B25125_013E',
            'B25125_014E',
            'B25125_015E',
            'B25125_016E',
            'B25125_017E',
            'B25125_018E',
            'B25125_019E',
            'B25125_020E',
            'B25125_021E',
            'B25125_022E',
            'B25125_023E',
            'B25125_024E',
            'B25125_025E',
            'B25125_026E',
            'B25125_027E',
            'B25125_028E',
            'B25125_029E',
            'B25125_030E',
            'B25125_032E',
            'B25125_033E',
            'B25125_034E',
            'B25125_035E',
            'B25125_036E',
            'B25125_037E',
            'B25125_038E',
            'B25125_039E',
            'B25125_040E',
            'B25125_041E',
            'B25125_042E',
            'B25125_043E',
            'B25125_044E',
            'B25125_045E'
        ]
    },
    B25102:{
        name: 'Mortgage Status by Real Estate Taxes Paid',
        variables:[
            'B25102_001E',
            'B25102_002E',
            'B25102_003E',
            'B25102_004E',
            'B25102_005E',
            'B25102_006E',
            'B25102_007E',
            'B25102_008E',
            'B25102_009E',
            'B25102_010E',
            'B25102_011E',
            'B25102_012E',
            'B25102_013E',
            'B25102_014E',
            'B25102_015E'
        ]
    },
    B25002:{
        name: 'Occupancy Status',
        variables:[
            'B25002_001E',
            'B25002_002E',
            'B25002_003E'
        ]
    },
    B15003:{
        name: 'Educational Attainment among adults 25  and older',
        variables:[
            'B15003_001E',
            'B15003_002E',
            'B15003_003E',
            'B15003_004E',
            'B15003_005E',
            'B15003_006E',
            'B15003_007E',
            'B15003_008E',
            'B15003_009E',
            'B15003_010E',
            'B15003_011E',
            'B15003_012E',
            'B15003_013E',
            'B15003_014E',
            'B15003_015E',
            'B15003_016E',
            'B15003_017E',
            'B15003_018E',
            'B15003_019E',
            'B15003_020E',
            'B15003_021E',
            'B15003_022E',
            'B15003_023E',
            'B15003_024E',
            'B15003_025E'
        ]
    },
    B21002:{
        name: 'Veterans Population',
        variables:[
            'B21002_001E',
            'B21002_002E',
            'B21002_003E',
            'B21002_004E',
            'B21002_005E',
            'B21002_006E',
            'B21002_007E',
            'B21002_008E',
            'B21002_009E',
            'B21002_010E',
            'B21002_011E',
            'B21002_012E',
            'B21002_013E',
            'B21002_014E',
            'B21002_015E',
            'B21002_016E'
        ]
    }





    B25075:{
        name: 'Housing Units Value by Bucket',
        variables:[
            //These have 27 variables mentioned in the excel but 25 on the acs census list
        ]
    },
     ------------------------For the variable B16001 ---------------------------------------

          {name:'Scandinavian Languages Speak English very well',value:'B16001_028E'},
          {name:'Scandinavian Languages Speak English Less than very well',value:'B16001_029E'},
          {name:'Thai Speak English very well ',value:'B16001_082E'},
          {name:'Thai Speak English Less than very well ',value:'B16001_083E'},
          {name:'Loatian Speak English very well ',value:'B16001_085E'},
          {name:'Loatian Speak English Less than very well ',value:'B16001_086E'},
          {name:'Vietnamese Speak English very well ',value:'B16001_088E'},
          {name:'Vietnamese Speak English Less than very well ',value:'B16001_089E'},
          {name:'Armenian Speak English very well',value:'B16001_046E'},
          {name:'Armenian Speak English Less than very well',value:'B16001_047E'},
          {name:'Hmong Speak English very well ',value:'B16001_079E'},
          {name:'Hmong Speak English Less than very well ',value:'B16001_080E'},
          {name:'Other Pacific Island Languages Speak English very well ',value:'B16001_097E'},
          {name:'Other Pacific Island Languages Speak English Less than very well ',value:'B16001_098E'},
          {name:'Other Native North American Languages Speak English very well ',value:'B16001_103E'},
          {name:'Other Native North American Languages Speak English Less than very well ',value:'B16001_104E'},
          {name:'Hungarian Speak English very well ',value:'B16001_106E'},
          {name:'Hungarian Speak English Less than very well ',value:'B16001_107E'},
          {name:'Arabic Speak English very well ',value:'B16001_109E'},
          {name:'Arabic Speak English Less than very well ',value:'B16001_110E'},
          {name:'Hebrew Speak English very well ',value:'B16001_112E'},
          {name:'Hebrew Speak English Less than very well ',value:'B16001_113E'},
          {name:'African Languages Speak English very well ',value:'B16001_115E'},
          {name:'African Languages Speak English Less than very well ',value:'B16001_116E'}
     */
